import { Result } from 'antd'

import './index.css'
const SuccessFormPage = ({ currentData }) => {
    return (
        <Result
            status="success"
            icon={
                <svg
                    width="150"
                    height="150"
                    viewBox="0 0 150 150"
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    aria-label="Application submitted"
                >
                    <path
                        d="M40 30c25-15 70-15 95 15s5 65-25 75-65 5-80-20-15-55 10-70z"
                        fill="#E9ECEF"
                    />

                    <g>
                        <circle cx="75" cy="70" r="35" fill="#6D7782" />
                        <path d="M60 95 L55 110 L70 100 Z" fill="#6D7782" />
                    </g>

                    <path
                        d="M63 70 l12 12 l20 -20"
                        fill="none"
                        stroke="#FFFFFF"
                        stroke-width="6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            }
            rootClassName="public-page-success"
            title="Thank you!"
            subTitle={
                <>
                    <h5>Your application has been submitted successfully.</h5>
                    <h6>
                        A copy of your application will be sent to{' '}
                        <b>{currentData?.personalEmail}</b> for your records.
                    </h6>
                </>
            }
            style={{
                width: '100%',
            }}
        />
    )
}

export default SuccessFormPage
